import React, { useEffect } from 'react';
import { DEFAULT_COUNTRY } from '../../../../helpers/countries';
import { useRouter } from 'next/router';
import Spinner from '../../../../components/Spinner';
import {
  getGeolocationCountry,
  getMyIp
} from '../../../../fetchers/geolocation';

/* 
Per esempio chiamo le url dalla svizzera:
uynsports.com/lang/de/shop/damen/kleidung/laufen/hemden
diventa
uynsports.com/de_ch/shop/damen/kleidung/laufen/hemden
*/

const RedirectLang = () => {
  const router = useRouter();

  useEffect(() => {
    if (router.isReady) {
      redirectLang();
    }
  }, [router.isReady]);

  const redirectLang = async () => {
    const { query, asPath } = router;
    const { lang, slug } = query;
    const _slug = Array.isArray(slug) ? slug.join('/') : slug;
    const querystring = asPath.split(/\?(.+)/)[1];

    let country = DEFAULT_COUNTRY;
    const ip = await getMyIp();
    if (ip) {
      const newGeoCountry = await getGeolocationCountry(ip);
      if (newGeoCountry) {
        country = newGeoCountry.toLowerCase();
      }
    }

    const path = `/${lang}_${country}/${_slug}${
      querystring ? '?' + querystring : ''
    }`;

    if (window && window.location) {
      window.location.replace(path);
    } else {
      router.replace(path);
    }
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <Spinner />
    </div>
  );
};

export default RedirectLang;
